import Slider from "../components/Slider";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import "./Home.scss";

const BASE_URL = "https://laurephilippe.fr";
const Home = ({
  slider,
  entrance,
  activeInfoIds,
  setActiveInfoIds,
  setShowInfo,
}) => {
  const location = useLocation();
  const photos = entrance?.photos || slider?.photos || [];
  return (
    <div className="home">
      <Helmet>
        <title>Laure Philippe</title>
        <link rel="canonical" href={`${BASE_URL}${location.pathname}`} />
      </Helmet>
      <Slider
        photos={photos}
        activeInfoIds={activeInfoIds}
        setActiveInfoIds={setActiveInfoIds}
        setShowInfo={setShowInfo}
      />
    </div>
  );
};

export default Home;
